import React, { useContext } from "react";
import { AppContext } from "../context/app.context";

/**
 * #139 Next Day Openings Dashboard — header circle button.
 *
 * Visibility:
 *   - hidden when whichList is "logs" or "userList" (those screens don't
 *     have a tomorrow-openings concept — Logs is its own audit view,
 *     UserList is admin user management)
 *   - hidden when not logged in (parent Header conditionally renders
 *     access-gated buttons only when mongoUser exists; this component
 *     additionally checks the dashboardAccess gate)
 *   - hidden when `tsUserDocument.dashboardAccess !== true`
 *
 * Visual: matches the circular outline style of the "?" help icon and the
 * "🕒" Time Machine button, with a bar-chart emoji (📊) centered as a
 * placeholder. Final icon TBD — replace with a specific Heroicons icon or
 * SVG when Brandon picks one.
 *
 * Click opens the dashboard modal via setOpenDashboardModal({ show: true }).
 */
const DashboardButton = () => {
  const { setOpenDashboardModal, whichList } = useContext(AppContext);

  if (whichList === "logs" || whichList === "userList") {
    return null;
  }

  const handleClick = () => {
    setOpenDashboardModal({ show: true });
  };

  return (
    <button
      onClick={handleClick}
      type="button"
      title="Next Day Openings"
      aria-label="Open next day openings dashboard"
      className="w-7 h-7 ml-4 rounded-full border-2 border-skin-link text-skin-link font-bold leading-none flex items-center justify-center hover:opacity-75"
    >
      <span aria-hidden="true">{"\u{1F4CA}"}</span>
    </button>
  );
};

export default DashboardButton;
